import { asyncComponent, asyncNamedComponent } from '@app/helpers/AsyncFunc';

export const routes = [
  {
    path: '',
    component: asyncNamedComponent(async () => {
      const { Widgets } = await import('../Widgets');
      return Widgets;
    }),
  },
  {
    path: 'userSettings',
    component: asyncNamedComponent(async () => {
      const { SingleUser } = await import('../Users/singleUser');
      return SingleUser;
    }),
  },
  {
    path: 'zoho/authorize',
    component: asyncComponent(() => import('../ThirdParty/zoho')),
  },
  {
    path: 'accounts/:accountId',
    component: asyncNamedComponent(async () => {
      const { SingleAccount } = await import('../Accounts/singleAccount');
      return SingleAccount;
    }),
  },
  {
    path: 'accounts',
    component: asyncNamedComponent(async () => {
      const { Accounts } = await import('../Accounts');
      return Accounts;
    }),
  },
  {
    path: 'deals/:dealId',
    component: asyncNamedComponent(async () => {
      const { SingleDeal } = await import('../Deals/singleDeal');
      return SingleDeal;
    }),
  },
  {
    path: 'deals',
    component: asyncNamedComponent(async () => {
      const { Deals } = await import('../Deals');
      return Deals;
    }),
  },
  {
    path: 'contacts/:contactId',
    component: asyncComponent(() => import('../Contacts/singleContact')),
  },
  {
    path: 'contacts',
    component: asyncNamedComponent(async () => {
      const { Contacts } = await import('../Contacts');
      return Contacts;
    }),
  },
  {
    path: 'campaigns',
    component: asyncNamedComponent(async () => {
      const { Campaigns } = await import('../Campaigns');
      return Campaigns;
    }),
  },
  {
    path: 'designs/:designId/builder/:prototypeId',
    component: asyncNamedComponent(async () => {
      const { DesignArtBuilder } = await import('../DesignArt/DesignArtBuilder');
      return DesignArtBuilder;
    }),
  },
  {
    path: 'designs/:designId',
    component: asyncNamedComponent(async () => {
      const { SingleDesign } = await import('../Designs/single');
      return SingleDesign;
    }),
  },
  {
    path: 'designs',
    component: asyncNamedComponent(async () => {
      const { DesignsList } = await import('../Designs');
      return DesignsList;
    }),
  },
  {
    path: 'styles/:styleId',
    component: asyncNamedComponent(async () => {
      const { SingleStyle } = await import('../Styles/single');
      return SingleStyle;
    }),
  },
  {
    path: 'styles',
    component: asyncNamedComponent(async () => {
      const { Styles } = await import('../Styles');
      return Styles;
    }),
  },
  {
    path: 'forecasts',
    component: asyncNamedComponent(async () => {
      const { Forecasts } = await import('../Forecasts');
      return Forecasts;
    }),
  },
  {
    path: 'artjobs',
    component: asyncNamedComponent(async () => {
      const { ArtJobs } = await import('../ArtJobs');
      return ArtJobs;
    }),
  },
  {
    path: 'artjobs/timesheet',
    component: asyncNamedComponent(async () => {
      const { ArtTimesheet } = await import('../ArtJobs/timesheet');
      return ArtTimesheet;
    }),
  },
  {
    path: 'artjobs/:artJobId',
    component: asyncNamedComponent(async () => {
      const { SingleArtJob } = await import('../ArtJobs/single');
      return SingleArtJob;
    }),
  },
  {
    path: 'teamstores',
    component: asyncNamedComponent(async () => {
      const { TeamStores } = await import('../TeamStores');
      return TeamStores;
    }),
  },
  {
    path: 'teamstores/:teamstoreId',
    component: asyncNamedComponent(async () => {
      const { SingleTeamStore } = await import('../TeamStores/single');
      return SingleTeamStore;
    }),
  },
  {
    path: 'purchaseorders',
    component: asyncNamedComponent(async () => {
      const { PurchaseOrders } = await import('../PurchaseOrders');
      return PurchaseOrders;
    }),
  },
  {
    path: 'printavoinvoices/:invoiceId',
    component: asyncNamedComponent(async () => {
      const { PrintavoInvoice } = await import('../PrintavoInvoices/single');
      return PrintavoInvoice;
    }),
  },
  {
    path: 'printavoinvoices',
    component: asyncNamedComponent(async () => {
      const { PrintavoInvoices } = await import('../PrintavoInvoices');
      return PrintavoInvoices;
    }),
  },
  {
    path: 'invoicematching/:invoiceId',
    component: asyncNamedComponent(async () => {
      const { InvoiceMatchingWorkspace } = await import(
        '../InvoiceMatching/single'
      );
      return InvoiceMatchingWorkspace;
    }),
  },
  {
    path: 'invoicematching',
    component: asyncNamedComponent(async () => {
      const { InvoiceMatching } = await import('../InvoiceMatching');
      return InvoiceMatching;
    }),
  },
  {
    path: 'purchaseorderchangerequests',
    component: asyncNamedComponent(async () => {
      const { PurchaseOrderChangeRequests } = await import(
        '../PurchaseOrderChangeRequests'
      );
      return PurchaseOrderChangeRequests;
    }),
  },
  {
    path: 'purchaseorderneedsapproval',
    component: asyncNamedComponent(async () => {
      const { PurchaseOrderNeedsApproval } = await import(
        '../PurchaseOrders/needsApproval'
      );
      return PurchaseOrderNeedsApproval;
    }),
  },
  {
    path: 'purchaseorders/:purchaseorderID',
    component: asyncNamedComponent(async () => {
      const { SinglePurchaseOrder } = await import('../PurchaseOrders/single');
      return SinglePurchaseOrder;
    }),
  },
  {
    path: 'purchaseorders/:purchaseOrderId/receiving',
    component: asyncNamedComponent(async () => {
      const { PurchaseOrderReceivingPage } = await import(
        '../PurchaseOrders/receivingPage'
      );
      return PurchaseOrderReceivingPage;
    }),
  },
  {
    path: 'purchases/create',
    component: asyncComponent(
      () => import('../PurchaseOrders/createPurchaseOrder')
    ),
  },
  {
    path: 'fulfillments',
    component: asyncNamedComponent(async () => {
      const { FulfillmentOrders } = await import('../FulfillmentOrders');
      return FulfillmentOrders;
    }),
  },
  {
    path: 'fulfillments/:id',
    component: asyncNamedComponent(async () => {
      const { SingleFulFillment } = await import('../FulfillmentOrders/single');
      return SingleFulFillment;
    }),
  },
  {
    path: 'fulfillment-groups',
    component: asyncNamedComponent(async () => {
      const { FulfillmentGroups } = await import('../FulfillmentGroups');
      return FulfillmentGroups;
    }),
  },
  {
    path: 'fulfillment-groups/:name',
    component: asyncNamedComponent(async () => {
      const { SingleFulfillmentGroup } = await import(
        '../FulfillmentGroups/single'
      );
      return SingleFulfillmentGroup;
    }),
  },

  {
    path: 'workorders',
    component: asyncNamedComponent(async () => {
      const { WorkOrders } = await import('../WorkOrders');
      return WorkOrders;
    }),
  },
  {
    path: 'workorders/:workorderID',
    component: asyncNamedComponent(async () => {
      const { SingleWorkOrder } = await import('../WorkOrders/single');
      return SingleWorkOrder;
    }),
  },

  {
    path: 'supplierswo',
    component: asyncNamedComponent(async () => {
      const { SupplierWorkOrders } = await import('../SupplierWorkOrders');
      return SupplierWorkOrders;
    }),
  },
  {
    path: 'supplierswo/:supplierWorkOrderID',
    component: asyncNamedComponent(async () => {
      const { SingleSupplierWorkOrder } = await import(
        '../SupplierWorkOrders/single'
      );
      return SingleSupplierWorkOrder;
    }),
  },
  {
    path: 'supplierswo/:supplierWorkOrderId/receive',
    component: asyncNamedComponent(async () => {
      const { SupplierWorkOrderReceivingPage } = await import(
        '../SupplierWorkOrders/receivingPage'
      );
      return SupplierWorkOrderReceivingPage;
    }),
  },

  {
    path: 'settings',
    component: asyncNamedComponent(async () => {
      const { Settings } = await import('../Settings');
      return Settings;
    }),
  },
  {
    path: 'supplierCatalogs/:supplierId',
    component: asyncNamedComponent(async () => {
      const { ManualCatalog } = await import('../Settings/ManualCatalog');
      return ManualCatalog;
    }),
  },
  {
    path: 'snippets',
    component: asyncNamedComponent(async () => {
      const { Snippets } = await import('../Snippets');
      return Snippets;
    }),
  },
  {
    path: 'snippets/:snipId',
    component: asyncNamedComponent(async () => {
      const { SingleSnippet } = await import('../Snippets/single');
      return SingleSnippet;
    }),
  },
  {
    path: 'prodoTemplates',
    component: asyncNamedComponent(async () => {
      const { ProdoTemplates } = await import('../ProdoTemplates');
      return ProdoTemplates;
    }),
  },
  {
    path: 'prodoTemplates/:snipId',
    component: asyncNamedComponent(async () => {
      const { SingleProdoTemplate } = await import('../ProdoTemplates/single');
      return SingleProdoTemplate;
    }),
  },
  {
    path: 'printables',
    component: asyncNamedComponent(async () => {
      const { Printables } = await import('../Printables');
      return Printables;
    }),
  },
  {
    path: 'printables/:printableId',
    component: asyncNamedComponent(async () => {
      const { SinglePrintable } = await import('../Printables/single');
      return SinglePrintable;
    }),
  },
  {
    path: 'printables/:printableId/design',
    component: asyncNamedComponent(async () => {
      const { PrintableDesigner } = await import('../Printables/designer');
      return PrintableDesigner;
    }),
  },
  {
    path: 'npssurveys',
    component: asyncNamedComponent(async () => {
      const { NpsSurveys } = await import('../NpsSurveys');
      return NpsSurveys;
    }),
  },
  {
    path: 'artcodes',
    component: asyncNamedComponent(async () => {
      const { Artcodes } = await import('../Artcodes');
      return Artcodes;
    }),
  },
  {
    path: 'artcodes/:artcodeCode',
    component: asyncNamedComponent(async () => {
      const { SingleArtcode } = await import('../Artcodes/single');
      return SingleArtcode;
    }),
  },
  {
    path: 'supplierpo/:suppoid',
    component: asyncNamedComponent(async () => {
      const { SingleSupplierPurchaseOrder } = await import(
        '../SupplierPurchaseOrder/single'
      );
      return SingleSupplierPurchaseOrder;
    }),
  },
  {
    path: 'salesorders',
    component: asyncNamedComponent(async () => {
      const { SalesReceipts } = await import('../SalesReceipts');
      return SalesReceipts;
    }),
  },
  {
    path: 'salesorders/:salesOrderId',
    component: asyncNamedComponent(async () => {
      const { SingleSalesReceipt } = await import('../SalesReceipts/single');
      return SingleSalesReceipt;
    }),
  },
  {
    path: 'salesdrafts',
    component: asyncNamedComponent(async () => {
      const { SalesDrafts } = await import('../SalesDrafts');
      return SalesDrafts;
    }),
  },
  {
    path: 'salesdrafts/new',
    component: asyncNamedComponent(async () => {
      const { CreateSalesDraft } = await import('../SalesDrafts/createNew');
      return CreateSalesDraft;
    }),
  },
  {
    path: 'salesdrafts/:salesDraftId/edit',
    component: asyncNamedComponent(async () => {
      const { SingleSalesDraftEdit } = await import(
        '../SalesDrafts/singleEdit'
      );
      return SingleSalesDraftEdit;
    }),
  },
  {
    path: 'salesdrafts/:salesDraftId',
    component: asyncNamedComponent(async () => {
      const { SingleSalesDraft } = await import('../SalesDrafts/single');
      return SingleSalesDraft;
    }),
  },
  {
    path: 'emails',
    component: asyncNamedComponent(async () => {
      const { EmailSystem } = await import('../Emails');
      return EmailSystem;
    }),
  },
  {
    path: 'bin/reconcile',
    component: asyncNamedComponent(async () => {
      const { ReconcileBin } = await import('../Location/reconcileBin');
      return ReconcileBin;
    }),
  },
  {
    path: 'location/inventory/eventreceivings',
    component: asyncNamedComponent(async () => {
      const { EventReceivingsTable } = await import(
        '../Location/Inventory/EventReceiving/table'
      );
      return EventReceivingsTable;
    }),
  },
  {
    path: 'location/inventory/eventreceiving/:id',
    component: asyncNamedComponent(async () => {
      const { EventReceivingPage } = await import(
        '../Location/Inventory/EventReceiving/detail'
      );
      return EventReceivingPage;
    }),
  },
  {
    path: 'location/inventory/pickings',
    component: asyncNamedComponent(async () => {
      const { LocationPickingsTable } = await import(
        '../Location/Inventory/Pickings/table'
      );
      return LocationPickingsTable;
    }),
  },
  {
    path: 'location/inventory/picking/:id',
    component: asyncNamedComponent(async () => {
      const { PickingPage } = await import(
        '../Location/Inventory/Pickings/detail'
      );
      return PickingPage;
    }),
  },
  {
    path: 'location/inventory/putaway',
    component: asyncNamedComponent(async () => {
      const { LocationPutawaysTable } = await import(
        '../Location/Inventory/Putaway/table'
      );
      return LocationPutawaysTable;
    }),
  },

  {
    path: 'location/inventory/putaway/:id',
    component: asyncNamedComponent(async () => {
      const { LocationPutawayPage } = await import(
        '../Location/Inventory/Putaway/detail'
      );
      return LocationPutawayPage;
    }),
  },
  {
    path: 'location/inventory/products',
    component: asyncNamedComponent(async () => {
      const { LocationProductVariantsTable } = await import(
        '../Location/Inventory/Products/table'
      );
      return LocationProductVariantsTable;
    }),
  },
  {
    path: 'location/inventory/bins',
    component: asyncNamedComponent(async () => {
      const { LocationBinsTable } = await import('../Location/Inventory/Bins');
      return LocationBinsTable;
    }),
  },
  {
    path: 'testing/scans',
    component: asyncNamedComponent(async () => {
      const { ScanTest } = await import('../Testing/scans');
      return ScanTest;
    }),
  },
  {
    path: 'resources',
    component: asyncNamedComponent(async () => {
      const { ResourcePage } = await import('../ResourceCenter');
      return ResourcePage;
    }),
  },
  {
    path: 'resources/edit',
    component: asyncNamedComponent(async () => {
      const { ResourceEditor } = await import('../ResourceCenter/editor');
      return ResourceEditor;
    }),
  },
  {
    path: 'feedback/:feedbackId',
    component: asyncNamedComponent(async () => {
      const { SingleFeedback } = await import('../Feedback/single');
      return SingleFeedback;
    }),
  },
  {
    path: 'feedback',
    component: asyncNamedComponent(async () => {
      const { FeedbackPage } = await import('../Feedback');
      return FeedbackPage;
    }),
  },
];
